export const REDUCER_NAME = "addPurchaseOrderSlice";

export interface iPurchaseOrderDTO {
  purchaseOrderNumber: string;
  productName: string;
  itemCode: string;
  hsnCode: string;
  uom: string;
  quantity: number;
  rate: number;
  discount: number;
  taxType: string;
  taxRate: number;
  warehouse: string;
  batchNumber: string;
  expiryDate: string;
  description: string;
  remarks: string;
  companyName: string;
  companyAddress: string;
  cityPincode: string;
  phone: string;
  email: string;
  gstin: string;
  orderNo: string;
  date: string;
  amendmentDetails: string;
  reference: string;
  poValidity: string;
  supplierName: string;
  supplierAddress: string;
  supplierGstin: string;
  deliveryCompanyName: string;
  deliveryAddress: string;
  deliveryCityPincode: string;
  preparedBy: string;
  preparedDate: string;
  approvedBy: string;
  notes: string;
}

export interface iAddPurchaseOrderState {
  isLoading: boolean;
  isSuccess: boolean;
  error: string | null;
  orderData: any | null;
}
